import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getDashboardAuditReports = async (token, dashboardId) => {
  const url = `dashboards/${dashboardId}/audit_reports`

  const data = await apiGet({ url, token })
  return data
}

export const useDashboardAuditReports = ({ dashboardId, options = {} }) => {
  const token = useContext(AuthContext)
  const queryFn = () => getDashboardAuditReports(token, dashboardId)
  const queryKey = ['dashboard-audit-reports', dashboardId]

  return useQuery(queryKey, queryFn, {
    enabled: !!dashboardId,
    ...options
  })
}
